<template>
  <div class="services">
    <el-popover placement="left" trigger="click" width="300" @show="open" @hide="close">
      <el-button slot="reference" icon="el-icon-share" circle ></el-button>
      <div class="services__list">
        <div v-for="(value, key) in services" :key="key"
             class="services__list--item">
              <span class="services__list--item-title">
                <img :class="key" :src="serviceImage(value.name)" :alt="key">
                {{ value.name }}
              </span>
          <div class="services__list--item-options">
            <div v-if="value">
              <el-radio-group :value="value.approved" size="small">
                <div class="mr5" @click.once="updateService(value.id, 1)">
                  <el-radio-button :label="1">YES</el-radio-button>
                </div>
                <div class="mr5" @click.once="updateService(value.id, 0)">
                  <el-radio-button :label="0">NO</el-radio-button>
                </div>
              </el-radio-group>
            </div>
            <i v-else class="el-icon-error fa-lg"></i>
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from "vuex";

export default {
  data() {
    return {
    }
  },

  props: {
    user: { type: Number, default: null },
    tab: { type: String, default: null }
  },

  computed: {
    ...mapState('user', ['services'])
  },

  methods: {
    ...mapActions('artistUsers', ['readArtistUsers']),
    ...mapActions('labelUsers', ['readLabelUsers']),
    ...mapActions('user', ['updateUserService',  'readServices', 'getCompanyAdminArtist']),
    ...mapMutations('user', ['setServices']),

    open(){
      this.setServices([])
      this.readServices(this.user)
    },

    close(){
      this.setServices([])
    },

    serviceImage(service) {
      let s = service.toLowerCase()
      return require(`@/assets/icons/${s}-B.svg`)
    },

    updateService(service, status) {
      const data = { user: this.user, service: service, status:  status}
      this.updateUserService(data).then(() => {
        this.setServices([])
        this.readServices(this.user)
        if(this.tab == 'artists'){
          this.readArtistUsers()
          this.getCompanyAdminArtist()
        }
        else if(this.tab == 'labels'){
          this.readLabelUsers()
          this.getCompanyAdminArtist()
        }
      })
    }
  },
}
</script>

<style scoped lang="scss">

.services {
  display: inline-block;
  margin-left: 10px;
  text-align: center;

  &__list {

    &--item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &:not(:first-child) {
        margin-top: 20px;
      }
    }
    &--item-options {
      text-align: center;
      width: 216px;
      i {
        color: #605677;;
      }
    }
    &--item-title {
      display: flex;
      align-items: center;
      margin-right: 20px;
      font-weight: 600;
      width: 190px;
      cursor: pointer;

      img {
        margin-right: 10px;
      }
    }
  }
}

</style>
